/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to repeat…`)
};

const es_tr_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a repetir…`)
};

const de_tr_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu wiederholender Text…`)
};

const nl_tr_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekst om te herhalen…`)
};

const fr_tr_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte à répéter…`)
};

const it_tr_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo da ripetere…`)
};

const pt_br2_tr_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto para repetir…`)
};

const pt_tr_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a repetir…`)
};

const ja_tr_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繰り返すテキスト…`)
};

const zh_tr_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要重复的文本…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_placeholder", locale)
	if (locale === "en") return en_tr_placeholder(inputs)
	if (locale === "es") return es_tr_placeholder(inputs)
	if (locale === "de") return de_tr_placeholder(inputs)
	if (locale === "nl") return nl_tr_placeholder(inputs)
	if (locale === "fr") return fr_tr_placeholder(inputs)
	if (locale === "it") return it_tr_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_tr_placeholder(inputs)
	if (locale === "pt") return pt_tr_placeholder(inputs)
	if (locale === "ja") return ja_tr_placeholder(inputs)
	return zh_tr_placeholder(inputs)
};